import { useSelector } from 'react-redux'

import { getModifierGroups } from 'store/Categories/selectors'

const useIsItemModifier = (itemCategoryUuids = []) => {
  const modifierGroups = useSelector(getModifierGroups)
  const modifierGroupsUuids = modifierGroups?.map(
    (modifierGroup) => modifierGroup?.uuid
  )

  const isItemModifier =
    itemCategoryUuids?.some((itemCategoryUuid) =>
      modifierGroupsUuids?.includes(itemCategoryUuid)
    ) ?? false

  return isItemModifier
}

export default useIsItemModifier
